import React, { useEffect, useState } from "react";
import axios from 'axios';
import './style.css';
import Links from "../../Data/Links";
import { store, updateDataEntryRecRow, clearDataEntryRecRow, updateCurrentEditDayRec } from "../../redux";
import Cookies from 'js-cookie';
import moment from 'moment';

const CreateRowRec = ({ row, day, filterData, dataEntryRec, loadData, editDay }) => {
    const [edit, setEdit] = useState({});
    const onChangeValue = (event, field) => {
        store.dispatch(updateDataEntryRecRow({ [field]: event.target.value ? event.target.value : 0 }));
    }
    const checkDatabaseTransactions = (day) => {
        const currentUser = JSON.parse(Cookies.get('user_data')).userName
        const dataEntryObject = { ...dataEntryRec, transaction_lock: 1, locked_user: currentUser, transaction_locked_at: new Date().toISOString().slice(0, 19).replace("T", " "), store_id: filterData.store_id, store_name: filterData.store_name, company: filterData.company, month: filterData.month, year: filterData.year, day: day.toString() }
        axios.post(Links.addRecDailyData, dataEntryObject)
            .then(res => {
                if (res.data.recordExist && res.data.recordExist === true) {
                    if (res.data.lockedUser !== currentUser) {
                        alert(res.data.message)
                        setEdit({ [day]: false });
                        store.dispatch(updateCurrentEditDayRec({ "currentEditDayRec": 0 }))
                        loadData(null, day)
                    } else {
                        setEdit({ [day]: true });
                        loadData(null, day)
                    }
                } else {
                    loadData(null, day);
                }
            }).catch(err => {
                console.log(err);
            });
    };

    const checkDatabaseTransactionsForEdit = (day, id) => {
        const currentUser = JSON.parse(Cookies.get('user_data')).userName
        const dataEntryObject = { ...row[day], transaction_lock: 1, locked_user: currentUser, transaction_locked_at: new Date().toISOString().slice(0, 19).replace("T", " "), store_id: filterData.store_id, store_name: filterData.store_name, company: filterData.company, month: filterData.month, year: filterData.year, day: day.toString(), saveOrEdit: 'edit' }
        axios.patch(Links.updateRecDailyDataById + '/' + id, { row: dataEntryObject })
            .then(res => {
                if (res.data.recordExist && res.data.recordExist === true) {
                    if (res.data.lockedUser !== currentUser) {
                        alert(res.data.message)
                        setEdit({ [day]: false });
                        store.dispatch(updateCurrentEditDayRec({ "currentEditDayRec": 0 }))
                        loadData(null, day)
                    } else {
                        setEdit({ [day]: true });
                        loadData(null, day)
                    }
                } else {
                    loadData(null, day);
                }
            }).catch(err => {
                console.log(err);
            });
    };
    const getTimeDifferenceInMinutes = (startTime, endTime) => {
        if (typeof startTime === 'undefined') {
            return false
        }
        const startDate = moment(startTime).unix()
        const timeEnd = moment(endTime).unix()
        const diff = (startDate - timeEnd)
        if ((60 - (diff / 60 % 60)).toFixed(2) < 3) {
            return true
        } else {
            return false
        }
    }
    const getTotalGross = (rowData = null) => {
        if (rowData != null) {
            if (filterData.store_name === 'FMS-Sask' || filterData.store_name === 'FMS-Yorkton' || filterData.store_name === 'FFUN Motorsports Winnipeg East' || filterData.store_name === 'FFUN Motorsports Winnipeg West'|| filterData.store_name === 'FFUN Motorsports Portage' || filterData.store_name === 'FFUN Motorsports Kenora') {
                let new_retail_front_GP = rowData.new_retail_front_GP ? parseInt(rowData.new_retail_front_GP) : 0;
                let new_retail_back_GP = rowData.new_retail_back_GP ? parseInt(rowData.new_retail_back_GP) : 0;
                let used_retail_front_GP = rowData.used_retail_front_GP ? parseInt(rowData.used_retail_front_GP) : 0;
                let used_retail_back_GP = rowData.used_retail_back_GP ? parseInt(rowData.used_retail_back_GP) : 0;
                let wholesale_total_GP = rowData.wholesale_total_GP ? parseInt(rowData.wholesale_total_GP) : 0;
                let service_total_GP = rowData.service_total_GP ? parseInt(rowData.service_total_GP) : 0;
                let parts_total_GP = rowData.parts_total_GP ? parseInt(rowData.parts_total_GP) : 0;
                let parts_whole_sale_GP = rowData.parts_whole_sale_GP ? parseInt(rowData.parts_whole_sale_GP) : 0;
                let boats_back_GP = rowData.boats_back_GP ? parseInt(rowData.boats_back_GP) : 0;
                let boats_front_GP = rowData.boats_front_GP ? parseInt(rowData.boats_front_GP) : 0;
                   let bikes_back_GP = rowData.bikes_back_GP ? parseInt(rowData.bikes_back_GP) : 0;
                let bikes_front_GP = rowData.bikes_front_GP ? parseInt(rowData.bikes_front_GP) : 0;
                let trailers_back_GP = rowData.trailers_back_GP ? parseInt(rowData.trailers_back_GP) : 0;
                let trailers_front_GP = rowData.trailers_front_GP ? parseInt(rowData.trailers_front_GP) : 0;
                let apparel_gross = rowData.apparel_gross ? parseInt(rowData.apparel_gross) : 0;
                let sum = new_retail_front_GP + new_retail_back_GP + used_retail_front_GP + used_retail_back_GP + wholesale_total_GP + service_total_GP + parts_total_GP + parts_whole_sale_GP
                    + boats_back_GP + boats_front_GP + trailers_back_GP + trailers_front_GP +bikes_front_GP+bikes_back_GP+ apparel_gross;
                return "$" + sum.toLocaleString();
            } else {
                let new_retail_front_GP = rowData.new_retail_front_GP ? parseInt(rowData.new_retail_front_GP) : 0;
                let new_retail_back_GP = rowData.new_retail_back_GP ? parseInt(rowData.new_retail_back_GP) : 0;
                let used_retail_front_GP = rowData.used_retail_front_GP ? parseInt(rowData.used_retail_front_GP) : 0;
                let used_retail_back_GP = rowData.used_retail_back_GP ? parseInt(rowData.used_retail_back_GP) : 0;
                let wholesale_total_GP = rowData.wholesale_total_GP ? parseInt(rowData.wholesale_total_GP) : 0;
                let service_total_GP = rowData.service_total_GP ? parseInt(rowData.service_total_GP) : 0;
                let parts_total_GP = rowData.parts_total_GP ? parseInt(rowData.parts_total_GP) : 0;
                let parts_whole_sale_GP = rowData.parts_whole_sale_GP ? parseInt(rowData.parts_whole_sale_GP) : 0;
                let apparel_gross = rowData.apparel_gross ? parseInt(rowData.apparel_gross) : 0;
                let sum = new_retail_front_GP + new_retail_back_GP + used_retail_front_GP + used_retail_back_GP + wholesale_total_GP + service_total_GP + parts_total_GP + parts_whole_sale_GP + apparel_gross;
                return "$" + sum.toLocaleString();
            }

        } else {
            return "$0";
        }
    }

    const renderBoatsAndTrailersValue = () => {
        if (filterData.store_name === 'FMS-Sask' || filterData.store_name === 'FMS-Yorkton' || filterData.store_name === 'FFUN Motorsports Winnipeg East' || filterData.store_name === 'FFUN Motorsports Winnipeg West'|| filterData.store_name === 'FFUN Motorsports Portage' || filterData.store_name === 'FFUN Motorsports Kenora') {
            return (<>
                {edit[day] ?
                    <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                        <input onChange={(e) => onChangeValue(e, "boats_delivered")} type="text" className="dn-input" value={dataEntryRec.boats_delivered}></input>
                    </td>
                    : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.boats_delivered>0 ? parseInt(row?.[day]?.boats_delivered).toLocaleString() : 0}</td>}

                {edit[day] ?
                    <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                        <input onChange={(e) => onChangeValue(e, "boats_front_GP")} type="text" className="dn-input" value={dataEntryRec.boats_front_GP}></input>
                    </td>
                    : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.boats_front_GP>0 ? '$' + row?.[day]?.boats_front_GP.toLocaleString() : '$' + 0}</td>}
                {edit[day] ?
                    <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                        <input onChange={(e) => onChangeValue(e, "boats_back_GP")} type="text" className="dn-input" value={dataEntryRec.boats_back_GP}></input>
                    </td>
                    : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.boats_back_GP>0 ? '$' + row?.[day]?.boats_back_GP.toLocaleString() : '$' + 0}</td>}
                {edit[day] ?
                    <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                        <input onChange={(e) => onChangeValue(e, "trailers_delivered")} type="text" className="dn-input" value={dataEntryRec.trailers_delivered}></input>
                    </td>
                    : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.trailers_delivered>0 ? row?.[day]?.trailers_delivered : 0}</td>}
                {edit[day] ?
                    <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                        <input onChange={(e) => onChangeValue(e, "trailers_front_GP")} type="text" className="dn-input" value={dataEntryRec.trailers_front_GP}></input>
                    </td>
                    : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.trailers_front_GP>0 ? '$' + parseInt(row?.[day]?.trailers_front_GP).toLocaleString() : '$' + 0}</td>}
                {edit[day] ?
                    <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                        <input onChange={(e) => onChangeValue(e, "trailers_back_GP")} type="text" className="dn-input" value={dataEntryRec.trailers_back_GP}></input>
                    </td>
                    : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.trailers_back_GP>0 ? '$' + parseInt(row?.[day]?.trailers_back_GP).toLocaleString() : '$' + 0}</td>}
            </>)
        } else {
            return <></>
        }
    }


     const renderBikesValue = () => {
        if (filterData.store_name === 'FMS-Sask' ) {
            return (<>
                {edit[day] ?
                    <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                        <input onChange={(e) => onChangeValue(e, "bikes_delivered")} type="text" className="dn-input" value={dataEntryRec.bikes_delivered}></input>
                    </td>
                    : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.bikes_delivered>0 ? parseInt(row?.[day]?.bikes_delivered).toLocaleString() : 0}</td>}

                {edit[day] ?
                    <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                        <input onChange={(e) => onChangeValue(e, "bikes_front_GP")} type="text" className="dn-input" value={dataEntryRec.bikes_front_GP}></input>
                    </td>
                    : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.bikes_front_GP>0 ? '$' + row?.[day]?.bikes_front_GP.toLocaleString() : '$' + 0}</td>}
                {edit[day] ?
                    <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                        <input onChange={(e) => onChangeValue(e, "bikes_back_GP")} type="text" className="dn-input" value={dataEntryRec.bikes_back_GP}></input>
                    </td>
                    : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.bikes_back_GP>0 ? '$' + row?.[day]?.bikes_back_GP.toLocaleString() : '$' + 0}</td>}
            </>)
        } else {
            return <></>
        }
    }


    let totalLeads = parseInt(row?.[day]?.phone_up || 0) + parseInt(row?.[day]?.fresh_up || 0) + parseInt(row?.[day]?.internet_lead || 0);
    return (
        <tr style={{ border: row[day]?.diff <= 3 && row[day]?.locked_user && row[day]?.locked_user !== "Undefined" && row[day]?.locked_user !== "undefined" && row[day]?.locked_user !== 'null' && row[day]?.locked_user !== JSON.parse(Cookies.get('user_data')).userName ? '2px solid red' : '', position: 'relative' }}>
            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }}><button className="button"
                    onClick={() => {
                        if (row[day]?.id) {
                            axios.patch(Links.updateRecDailyDataById + '/' + row[day]?.id, { row: { ...dataEntryRec, transaction_lock: 0, locked_user: JSON.parse(Cookies.get('user_data')).userName, transaction_locked_at: null, saveOrEdit: 'save' } })
                                .then(res => {
                                    if (res.data.recordExist && res.data.recordExist === true) {
                                        alert("Timeout! Please try again.");
                                        window.location.reload();

                                    } else {
                                        alert("Data Entry has been updated.");
                                        setEdit({ [day]: false });
                                        loadData(null, 0);
                                        store.dispatch(clearDataEntryRecRow());

                                    }
                                    store.dispatch(updateCurrentEditDayRec({ "currentEditDayRec": 0 }))
                                }).catch(err => {
                                    console.log(err);
                                });
                        }

                    }}
                >Save</button></td>
                :
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }}><button className="button"
                    onClick={() => {
                        // store.dispatch(updateCurrentEditDayRec({ "currentEditDayRec": day }))



                        if (editDay === 0) {
                            setEdit({ [day]: true })
                            row?.[day] ? checkDatabaseTransactionsForEdit(day, row[day].id) : checkDatabaseTransactions(day)
                            store.dispatch(updateCurrentEditDayRec({ "currentEditDayRec": day }))
                        }
                        else {
                            alert("Please save the data you are editing and try again.")
                        }
                        // store.dispatch(updateDataEntryRecRow({ ...filterData, ...row[day], 'day': day }));
                    }}
                >
                    {row?.[day] ? 'Edit' : 'Add'}
                </button></td>
            }
            <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }}><button className="button" onClick={() => {
                if (editDay === 0 && window.confirm("Are you sure want to delete?")) {
                    const currentUser = JSON.parse(Cookies.get('user_data')).userName
                    const dataEntryObject = { ...row[day], transaction_lock: 1, locked_user: currentUser, store_id: filterData.store_id, store_name: filterData.store_name, company: filterData.company, month: filterData.month, year: filterData.year, day: day.toString(), saveOrEdit: 'edit' }
                    axios.post(Links.deleteRecDailyData, { row: dataEntryObject })
                        .then(result => {

                            if (result.data.recordExist && result.data.recordExist === true) {
                                alert(result.data.message);
                                loadData(filterData)
                            } else {
                                alert("Deleted succussfully!");
                                store.dispatch(clearDataEntryRecRow());
                                // store.dispatch(updateCurrentEditDayRec({ "currentEditDayRec": 0 }))
                                loadData(filterData);
                            }

                        }).catch(err => {
                            console.log(err);
                        });
                }
                else {
                    alert("Please save the data you are editing and try again.")
                }
            }}>Delete</button></td>
            <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{day}</td>


            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "new_retail_delivered")} type="text" className="dn-input" value={dataEntryRec.new_retail_delivered}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.new_retail_delivered>0 ? row?.[day]?.new_retail_delivered : 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "new_retail_front_GP")} type="text" className="dn-input" value={dataEntryRec.new_retail_front_GP}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.new_retail_front_GP>0 ? '$' + parseInt(row?.[day]?.new_retail_front_GP).toLocaleString() : '$' + 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "new_retail_back_GP")} type="text" className="dn-input" value={dataEntryRec.new_retail_back_GP}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.new_retail_back_GP >0? '$' + parseInt(row?.[day]?.new_retail_back_GP).toLocaleString() : '$' + 0}</td>}
            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "used_retail_delivered")} type="text" className="dn-input" value={dataEntryRec.used_retail_delivered}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.used_retail_delivered>0 ? row?.[day]?.used_retail_delivered : 0}</td>}
            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "used_retail_front_GP")} type="text" className="dn-input" value={dataEntryRec.used_retail_front_GP}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.used_retail_front_GP>0 ? '$' + parseInt(row?.[day]?.used_retail_front_GP).toLocaleString() : '$' + 0}</td>}
            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "used_retail_back_GP")} type="text" className="dn-input" value={dataEntryRec.used_retail_back_GP}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.used_retail_back_GP>0 ? '$' + parseInt(row?.[day]?.used_retail_back_GP).toLocaleString() : '$' + 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "wholesale_retail_delivered")} type="text" className="dn-input" value={dataEntryRec.wholesale_retail_delivered}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.wholesale_retail_delivered>0 ? row?.[day]?.wholesale_retail_delivered : 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "wholesale_total_GP")} type="text" className="dn-input" value={dataEntryRec.wholesale_total_GP}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.wholesale_total_GP>0 ? '$' + parseInt(row?.[day]?.wholesale_total_GP).toLocaleString() : '$' + 0}</td>}
            
            {renderBoatsAndTrailersValue()}
            {renderBikesValue()}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "service_total_GP")} type="text" className="dn-input" value={dataEntryRec.service_total_GP}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.service_total_GP>0 ? '$' + parseInt(row?.[day]?.service_total_GP).toLocaleString() : '$' + 0}</td>}
  {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "service_total_hours")} type="text" className="dn-input" value={dataEntryRec.service_total_hours}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.service_total_hours>0 ? row?.[day]?.service_total_hours.toLocaleString() : 0}</td>}

           

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "service_CP_hours")} type="text" className="dn-input" value={dataEntryRec.service_CP_hours}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.service_CP_hours>0 ? row?.[day]?.service_CP_hours.toLocaleString() : 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "service_CP_ROs")} type="text" className="dn-input" value={dataEntryRec.service_CP_ROs}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.service_CP_ROs>0 ? row?.[day]?.service_CP_ROs.toLocaleString() : 0}</td>}

   
            {/* {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "service_hours_available")} type="text" className="auto-input" value={dataEntryRec.service_hours_available}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.service_hours_available>0 ? parseInt(row?.[day]?.service_hours_available).toLocaleString() : 0}</td>}

{edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "service_hours_sold")} type="text" className="auto-input" value={dataEntryRec.service_hours_sold}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.service_hours_sold>0 ? parseInt(row?.[day]?.service_hours_sold).toLocaleString() : 0}</td>}


            <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.service_total_hours>0 && row?.[day]?.service_hours_sold>0 ? (parseInt(row?.[day]?.service_hours_sold) / parseInt(row?.[day]?.service_total_hours)).toFixed(2) : 0}</td>


            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "service_no_of_tech")} type="text" className="auto-input" value={dataEntryRec.service_no_of_tech}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.service_no_of_tech>0 ? parseInt(row?.[day]?.service_no_of_tech).toLocaleString() : 0}</td>}


            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "service_journeyman")} type="text" className="auto-input" value={dataEntryRec.service_journeyman}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.service_journeyman>0 ? parseInt(row?.[day]?.service_journeyman).toLocaleString() : 0}</td>}


            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "service_apprentice")} type="text" className="auto-input" value={dataEntryRec.service_apprentice}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.service_apprentice>0 ? parseInt(row?.[day]?.service_apprentice).toLocaleString() : 0}</td>}


{edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "service_advisors_needed")} type="text" className="auto-input" value={dataEntryRec.service_advisors_needed}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.service_advisors_needed>0 ? parseInt(row?.[day]?.service_advisors_needed).toLocaleString() : 0}</td>} */}


            {/* {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "service_booked_hours")} type="text" className="auto-input" value={dataEntryRec.service_booked_hours}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.service_booked_hours ? parseInt(row?.[day]?.service_booked_hours).toLocaleString() : 0}</td>}
            */}
            {/* {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "service_units_shipped")} type="text" className="auto-input" value={dataEntryRec.service_units_shipped}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.service_units_shipped ? parseInt(row?.[day]?.service_units_shipped).toLocaleString() : 0}</td>}
 */}




            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "parts_sales")} type="text" className="dn-input" value={dataEntryRec.parts_sales}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.parts_sales>0 ? '$' + parseInt(row?.[day]?.parts_sales).toLocaleString() : '$' + 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "parts_total_GP")} type="text" className="dn-input" value={dataEntryRec.parts_total_GP}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.parts_total_GP>0 ? '$' + parseInt(row?.[day]?.parts_total_GP).toLocaleString() : '$' + 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input onChange={(e) => onChangeValue(e, "parts_whole_sale_GP")} type="text" className="dn-input" value={dataEntryRec.parts_whole_sale_GP}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.parts_whole_sale_GP>0 ? '$' + parseInt(row?.[day]?.parts_whole_sale_GP).toLocaleString() : '$' + 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input className="dn-input"
                        onChange={(e) => onChangeValue(e, "apparel_sales")} type="text"
                        value={dataEntryRec.apparel_sales}
                    ></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.apparel_sales>0 ? '$' + parseInt(row?.[day]?.apparel_sales).toLocaleString() : '$' + 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input className="dn-input"
                        onChange={(e) => onChangeValue(e, "apparel_gross")} type="text"
                        value={dataEntryRec.apparel_gross}
                    ></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.apparel_gross>0 ? '$' + parseInt(row?.[day]?.apparel_gross).toLocaleString() : '$' + 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                    <input className="dn-input"
                        onChange={(e) => onChangeValue(e, "apparel_inventory_value")} type="text"
                        value={dataEntryRec.apparel_inventory_value}
                    ></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">{row?.[day]?.apparel_inventory_value>0 ? '$' + parseInt(row?.[day]?.apparel_inventory_value).toLocaleString() : '$' + 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "appt_made")} type="text" className="auto-input" value={dataEntryRec.appt_made}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.appt_made>0 ? parseInt(row?.[day]?.appt_made).toLocaleString() : 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "booked")} type="text" className="auto-input" value={dataEntryRec.booked}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.booked>0 ? parseInt(row?.[day]?.booked).toLocaleString() : 0}</td>}


            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "appt_show")} type="text" className="auto-input" value={dataEntryRec.appt_show}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.appt_show>0 ? parseInt(row?.[day]?.appt_show).toLocaleString() : 0}</td>}

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "store_visit")} type="text" className="auto-input" value={dataEntryRec.store_visit}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.store_visit>0 ? parseInt(row?.[day]?.store_visit).toLocaleString() : 0}</td>}




            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "internet_lead")} type="text" className="auto-input" value={dataEntryRec.internet_lead}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.internet_lead>0 ? parseInt(row?.[day]?.internet_lead).toLocaleString() : 0}</td>}



            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "fresh_up")} type="text" className="auto-input" value={dataEntryRec.fresh_up}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.fresh_up>0 ? parseInt(row?.[day]?.fresh_up).toLocaleString() : 0}</td>}
            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "phone_up")} type="text" className="auto-input" value={dataEntryRec.phone_up}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.phone_up>0 ? parseInt(row?.[day]?.phone_up).toLocaleString() : 0}</td>}



            <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{parseInt(totalLeads).toLocaleString()}</td>

            {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "sales_staff")} type="text" className="auto-input" value={dataEntryRec.sales_staff}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.sales_staff>0 ? parseInt(row?.[day]?.sales_staff).toLocaleString() : 0}</td>}

            {/* {edit[day] ?
                <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">
                    <input onChange={(e) => onChangeValue(e, "no_show")} type="text" className="auto-input" value={dataEntryRec.no_show}></input>
                </td>
                : <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="auto-column">{row?.[day]?.no_show ? parseInt(row?.[day]?.no_show).toLocaleString() : 0}</td>} */}





            <td style={{ borderColor: 'rgba(0, 0, 0, 0.05)' }} className="dn-column">
                {getTotalGross(row?.[day])}
            </td>

            {row[day]?.diff <= 3 && row[day]?.locked_user && row[day]?.locked_user !== "Undefined" && row[day]?.locked_user !== "undefined" && row[day]?.locked_user !== 'null' && row[day]?.locked_user !== JSON.parse(Cookies.get('user_data')).userName &&
                <>
                    <div className="position-absolute text-capitalize text-center" style={{ backgroundColor: '#ff6961', color: 'white', left: '-1px', fontWeight: 'bold', fontSize: '17px', minWidth: '171px' }}>
                        {row[day]?.locked_user.split('.')[0]}
                    </div>
                </>
            }
        </tr>
    )
}

export default CreateRowRec;